module.exports = __webpack_public_path__ + "img/gitpage_icon.12602693.png";